import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('batteryMultiSelectPanelField');

    return {
        NO_BATTERIES_FOUND: t('noBatteriesFound'),
        SEARCH: t('search')
    };
};

export default useTranslation;
